import React, { useState, useEffect } from "react"
import moment from "moment"
import { getResolutionHeight } from "../../helpers/sharedHelperFunctions"

const Clock = () => {
  const [date, setDate] = useState(moment().format("ddd, D MMM"))
  const [time, setTime] = useState(moment().format("HH:mm"))

  useEffect(() => {
    setInterval(() => {
      setDate(moment().format("ddd, D MMM"))
      setTime(moment().format("HH:mm"))
    }, 5000)
  }, [])

  return (
    <div className="margin-left-desktop time-letter-spacing text-align-right white-text">
      <div className={`time-font-${getResolutionHeight()} time`}>{time}</div>
      <div className={`background-pil-${getResolutionHeight()}`}>
        <div className={`date-font-${getResolutionHeight()} date`}>{date}</div>
      </div>
      <div className={`disclaimer-text-${getResolutionHeight()} bold`}>
        Round may take ~10 minutes to update
      </div>
    </div>
  )
}

export default Clock
